'use strict';
require('../../../modules/es.array.index-of');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'indexOf');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/index-of.js
// module id = 560
// module chunks = 13